import(/* webpackMode: "eager" */ "/var/app/staging/app/(with-metadata)/(main)/media/media_2/page.tsx");
